/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.ImgSize[_ngcontent-%COMP%]{\n    height: 75% !important;\n}\n\n.my-pagination[_ngcontent-%COMP%]     .ngx-pagination .current {\n    background: #02b86e !important;\n}\n\n.oval[_ngcontent-%COMP%] {\n    top: 70px;\n    right: 30px;\n}\n\n.search-bar-interpreter[_ngcontent-%COMP%] {\n    height: 40px;\n    border-radius: 4px;\n    background-color: #F1F1F1;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9zaGFyZWQvdWkvaW50ZXJwcmV0ZXItcG9wdXAvaW50ZXJwcmV0ZXItcG9wdXAuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvc2hhcmVkL3VpL2ludGVycHJldGVyLXBvcHVwL2ludGVycHJldGVyLXBvcHVwLmNvbXBvbmVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/ui/interpreter-popup/interpreter-popup.component.css.shim.ngstyle.ts